import { render, staticRenderFns } from "./ScheduledOrders.vue?vue&type=template&id=04ef653b"
import script from "./ScheduledOrders.vue?vue&type=script&lang=js"
export * from "./ScheduledOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports